<template>
  <div class="image-full-width">
    <div class="cover">
      <UiComponentImage
        :key="screenWidth"
        :alt="image.alt"
        :expected-size="screenWidth"
        :height="image.height"
        :source="image.url"
        :width="image.width"
      />
    </div>
    <div class="content">
      <UiComponentTag
        v-if="hasTag"
        type="secondary"
      >
        <slot name="tag" />
      </UiComponentTag>
      <UiComponentHeading :level="level">
        <slot name="heading" />
      </UiComponentHeading>
    </div>
  </div>
</template>

<script setup>
// Composable
const { width: screenWidth } = useScreenSize()
const slots = useSlots()

// Props
const props = defineProps({
  image: {
    required: true,
    type: Object,
  },
  level: {
    default() {
      return 2
    },
    required: false,
    type: Number,
    validator(value) {
      return [2, 3, 4, 5, 6].indexOf(value) !== -1
    },
  },
})

// Computed Properties
const hasTag = computed(() => {
  const nodes = slots && slots.tag && slots.tag()
  return nodes && nodes.length > 0
})
</script>

<style lang="postcss" scoped>
.image-full-width {
  @apply relative items-center flex flex-col w-full;

  .cover {
    @apply flex items-center overflow-hidden;
    max-height: 640px;

    picture {
      @apply rounded-none;
    }
  }

  .content {
    @apply flex justify-center w-full px-4 py-8 bg-white;

    @screen md {
      @apply px-6;
    }

    @screen lg {
      @apply px-0;
    }

    @screen xl {
      @apply absolute pt-16 pb-2 rounded-t-lg;
      bottom: -40px;
      max-width: 1280px;
    }

    h2 {
      @apply text-center;
    }
  }
}
</style>
